import ProductFireIns from './ProductFireIns';
export default ProductFireIns;
